import { MagnifyingGlassPlusIcon } from '@phosphor-icons/react'

import { Icon } from '@/components/ui/icon'
import { ImagePreviewModal } from '@/components/ui/image-preview-modal'
import { popupFactory } from '@/factories'

import * as S from './zoomable-image.styled'

export interface ZoomableImageProps {
  src: string
  alt: string
  title: string
  width?: string
  height?: string
  fit?: 'contain' | 'cover'
  images?: string[]
  initialIndex?: number
}

export const ZoomableImage = ({
  src,
  alt,
  title,
  width = '10rem',
  height = '10rem',
  fit = 'cover',
  images,
  initialIndex,
}: ZoomableImageProps) => {
  const openPreview = () =>
    popupFactory.open(
      ImagePreviewModal,
      { alt, images: images ?? [src], initialIndex, title },
      { suspendCurrent: true },
    )

  return (
    <S.Container
      role="button"
      tabIndex={0}
      style={{ height, width }}
      onClick={openPreview}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          openPreview()
        }
      }}
    >
      <S.Image src={src} alt={alt} $fit={fit} />
      <S.Hint>
        <Icon icon={MagnifyingGlassPlusIcon} size="3.2rem" color="white" />
      </S.Hint>
    </S.Container>
  )
}
